
<template>
  <div class="lossReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">损失报表</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>日期</span>
            <el-date-picker 
            size="small" 
            v-model="order.startDate"
            type="date"
            :clearable="false"  
            placeholder="开始日期" 
            value-format="yyyy-MM-dd" 
            @change="changeTime(0)"
            :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker 
            size="small" 
            v-model="order.endDate"
            type="date"  
            :clearable="false"
            placeholder="结束日期" 
            @change="changeTime(1)"
            value-format="yyyy-MM-dd" 
            :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box">
            <span>基地</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="order.baseId" @change="baseChange">
              <el-option
                v-for="(item, index) in baseList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="pondList.length>0">
            <span>塘口</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="order.pondId" >
              <el-option
                v-for="(item, index) in pondList" 
                :key="index" 
                :label="item.value" 
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" >
            <span>品种</span>
           <el-select  filterable placeholder="请选择" size="small" v-model="order.fishId" style="">
              <el-option
                v-for="(item, index) in fishList"
                 :key="index" 
                :label="item.categoryName" 
                :value="item.categoryId">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>原因</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="order.lossWay" style="">
              <el-option
                v-for="(item, index) in reasonLossList"
                 :key="index" 
                :label="item.name" 
                :value="item.name">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box total">
            <span>汇总方式</span>
            <el-select v-model="groupBy" multiple size="middle"  placeholder="请选择" @change="setCache">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small"  type="info" plain  class="query" @click="search(1)">查询</el-button>
            <!-- <el-button size="small"  type="info" plain  class="add" >导出</el-button> -->
          </div>
          </div>
        </div>
      <div class="table-container">
        <!-- 表头 -->
        <table class="table-package" :class="isTop ? 'fix' : ''">
          <thead class="table-thead">
            <tr>
              <th v-if="showCol(2)">塘口</th>
              <th v-if="showCol(1)">品种</th>
              <th v-if="showCol(8)">损失原因</th>
              <th>损失重量(斤)</th>
              <th>损失数量</th>
            </tr>
          </thead>
        </table>
        <!-- 表体 -->
        <div class="scroll-box3" ref="scrollBox">
          <table class="table-package">
            <tbody class="table-tbodys" v-if=" this.order.details.length !== 0">
              <tr v-for="(item,index) in order.details" :key="index"  >
                <td v-if="showCol(2)" :rowspan="item.pondIdspan" :class="{hidden: item.pondIddis}">{{item.pondName}}</td>
                <td v-if="showCol(1)" :rowspan="item.fishCategoryIdspan" :class="{hidden: item.fishCategoryIddis}">{{item.fishName}}</td> 
                <td v-if="showCol(8)">{{item.fishLossWay}}</td> 
                <td>{{item.lossWeight|decimal}}</td> 
                <td>{{item.lossQuantity|decimal}}</td> 
              </tr>
            </tbody>
            <tbody class="table-tbodys" v-if=" this.order.details.length === 0">
              <tr>
                <td colspan="5">该时间段暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 表尾 -->
        <table class="table-package">
          <tfoot class="table-tfoot" v-if=" this.order.details.length !== 0">
            <tr class="row">
              <td v-if="showCol(2)">合计</td>
              <td v-if="showCol(1)">{{!showCol(2)?"合计":"--"}}</td>
              <td v-if="showCol(8)">{{!showCol(2)&&!showCol(1)?"合计":"--"}}</td>
              <td>{{total('lossWeight')|decimal}}</td>
              <td>{{total('lossQuantity')|decimal}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";

export default {
  mixins: [mixins],
  name: "lossReport",
  data() {
    return {
      options: [
        {
          value: "1",
          label: "品种"
        },
        {
          value: "2",
          label: "塘口"
        },
        {
          value: "8",
          label: "损失原因"
        }
      ],
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      order: {
        groupBy: 11, //汇总方式-默认全选
        baseId: "", //基地
        pondId: "", //塘口
        startDate: "", //开始时间
        endDate: "", //结束时间
        remark: "",
        details: [],
        fishId: "",
        lossWay: ""
      },
      groupBy: ["2"], //汇总方式
      baseList: [],
      pondList: [],
      fishList: [],
      reasonLossList: [],
      isTop: false,
      fixWidth: 0
    };
  },
  async mounted() {
    // 监听滚动
    window.addEventListener("scroll", this.getScroll, true);
    // 设置表头宽度
    this.fixWidth = this.$refs.scrollBox.offsetWidth - 5;
    window.onresize = () => {
      return (() => {
        this.fixWidth = this.$refs.scrollBox.offsetWidth;
      })();
    };

    let result = await Promise.all([
      this.getReasonList(), //损失原因
      this.getAllBaseList({ forQueryAll: true }) //基地
    ]);
    this.reasonLossList = [
      {
        id: "",
        name: "全部"
      }
    ].concat(result[0]);

    this.order.lossWay = this.reasonLossList[0].name;
    this.baseList = result[1];
    this.order.baseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    // this.order.baseId = this.baseList[0].key; //默认选中第一个基地
    await this.baseChange(this.order.baseId);
    this.getCache();
    this.search(1);
  },
  methods: {
    //监听滚动
    getScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 180) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },

    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    ...mapActions(modules.report, {
      GetLossReport: "GetLossReport" //报表数据
    }),
    ...mapActions(modules.fish, {
      getFishReport: "getFishReport" //品种
    }),
    ...mapActions(modules.dataDict, {
      getReasonList: "getReasonList" //损失原因
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    //动态合并表格
    combine(list, field, assistFields = []) {
      var k = 0;
      while (k < list.length) {
        list[k][field + "span"] = 1;
        list[k][field + "dis"] = false;
        for (var i = k + 1; i <= list.length - 1; i++) {
          let isEqual =
            list[k][field] == list[i][field] && list[k][field] != "";

          assistFields.forEach(item => {
            isEqual =
              isEqual &&
              (list[k][item] == list[i][item] && list[k][item] != "");
          });

          if (isEqual) {
            list[k][field + "span"]++;
            list[k][field + "dis"] = false;
            list[i][field + "span"] = 1;
            list[i][field + "dis"] = true;
          } else {
            break;
          }
        }
        k = i;
      }
      return list;
    },

    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total;
    },
    //汇总方式必须选一个
    showCol(value) {
      return (this.order.groupBy & value) > 0;
    },
    //改变基地数据
    async baseChange(e) {
      storage.set("base", e);
      this.pondList = [];
      let result = [];
      if (!e) {
        result = [];
      } else {
        result = await this.getFishPond(e);
      }
      this.pondList = [
        {
          key: "",
          value: "全部"
        }
      ].concat(result);
      if (this.pondList.length === 0) {
        this.$Alert.info({
          content: "当前选择的基地下面无塘口，请先添加",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地下面无塘口，请先添加");
      }
      this.order.pondId = "";
      this.getFish();
      this.order.fishId = "";
    },
    //改变塘口数据
    async pondChange(e) {
      this.getFish();
      this.order.fishId = "";
    },
    //品种
    getFish() {
      let obj = {
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        pondId: this.order.pondId
      };
      this.getFishReport(obj).then(rsp => {
        this.fishList = [
          {
            categoryId: "",
            categoryName: "全部"
          }
        ].concat(rsp);
      });
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.order.startDate);
      } else {
        storage.set("end", this.order.endDate);
      }
    },

    //查询
    async search() {
      let obj = {
        baseId: fishBaseIdForQuery(this.order.baseId, this.baseList),
        startDate: this.order.startDate,
        endDate: this.order.endDate,
        fishId: this.order.fishId,
        pondId: this.order.pondId,
        lossWay: this.order.lossWay,
        groupBy: this.groupBy.reduce((now, next) => Number(now) + Number(next))
      };
      try {
        if (obj.lossWay == "全部") {
          obj.lossWay = "";
        }
        this.order.details = this.combine(
          await this.GetLossReport(obj),
          "pondId"
        );

        this.order.details = this.combine(
          this.order.details,
          "fishCategoryId",
          ["pondId"]
        );

        this.order.groupBy = obj.groupBy;
      } catch (e) {
        this.$Alert.info({
          content: e.response.data,
          duration: 5000,
          status: "error"
        });
        // Message.error(e.response.data);
        // console.log(e);
      }
    },
    setCache(){
      localStorage.setItem('lossReportGroupBy', JSON.stringify(this.groupBy))
    },
    getCache(){
      const groupBy = localStorage.getItem('lossReportGroupBy')
      if(groupBy) this.groupBy = JSON.parse(groupBy)
    }
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.order.startDate = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      start.setMonth(0);
      this.order.startDate = this.$timeformatDay(start);
    }
    if (endTime) {
      this.order.endDate = endTime;
    } else {
      this.order.endDate = this.$timeformatDay(new Date());
    }
  },
  watch: {
    groupBy: function(val, oldVal) {
      if (val.length < 1) {
        this.$message({
          // showClose: true,
          message: "必须选中一项",
          type: "error"
        });
        // this.$Alert.info({
        //   content: "必须选中一项",
        //   duration: 3000,
        //   status: "error"
        // });
        this.groupBy = oldVal;
      }
    }
  }
};
</script>
<style lang="stylus" >
.lossReport
  margin-bottom:20px;
  .total{
      .el-select__tags{
      top:65%;
      height: 30px;
      overflow: auto;
    }
    .el-input__suffix{
      top:6px;
    }
    .is-focus .el-input__suffix {
      top:0px;
    }
  }
  .select-container-box:nth-child(1),.select-container-box:nth-child(3)
    .el-input--small
      width 135px!important
      height 38px!important
      min-width 135px!important
  .select-container-box:nth-child(6),.select-container-box:nth-child(7)
    .el-input--small
      width 96px!important
      height 38px!important
      min-width 96px!important
  .select-container-box:nth-child(9)
    .add,.query
      width:80px!important

  .scroll-box3
    width: 100%;
    // max-height:550px;
    // overflow: auto;
    // overflow-x:hidden;
  .table-package
    width 100%
    border-collapse collapse
    // border 1px #ddd solid
    border:none;
  .table-thead
    border-top: 2px solid rgb(51,137,255);
    
    >tr th
      width:294px;
      text-align center
      height: 50px;
      font-size: 12px;
      line-height: 50px;
      color #666;
      font-weight bold
      border: 1px solid #e0e0e0;
      border-bottom: 1px solid rgb(51,137,255);
      background-color: #f7f7f7;
  .table-tbodys
    :hover
      background:#c3e3ff;
    tr
      text-align center
      height 37px
      line-height 37px
      border: 1px solid #ddd;
      border:none;
      background-color #fff
      font-size: 12px;
    td
      width:294px;
      border 1px solid #e0e0e0
      color: #666;
      border-top:none;
      vertical-align:middle;
  .table-tfoot
    tr>td
      text-align center
      height 37px
      line-height 37px
      color: #333;
      font-size: 12px;
    .row
      font-size 12px
      background-color #fff
      font-weight bold

      >td
        width:294px;
        text-align center
        border 1px solid #e0e0e0
        // color: #666;
        border-top:none;
        font-weight:bold;
  .hidden
    display: none
.lossReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
  width: calc(100% - 250px);
}
</style>
